import { render, staticRenderFns } from "./BemVindo.vue?vue&type=template&id=12b7da6f&scoped=true"
import script from "./BemVindo.vue?vue&type=script&lang=js"
export * from "./BemVindo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7da6f",
  null
  
)

export default component.exports